import React, { useEffect } from 'react';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Header = ({ pageTitle, scrollPosition }) => {
  useEffect(() => {
    document.title = pageTitle;

    const toggleScrolled = () => {
      const body = document.body;
      const header = document.querySelector('#header');
      if (
        !header?.classList.contains('scroll-up-sticky') &&
        !header?.classList.contains('sticky-top') &&
        !header?.classList.contains('fixed-top')
      )
        return;
      window.scrollY > 100
        ? body.classList.add('scrolled')
        : body.classList.remove('scrolled');
    };

    const runToggleScrolled = () => toggleScrolled();
    document.addEventListener('scroll', runToggleScrolled);
    window.addEventListener('load', runToggleScrolled);

    return () => {
      document.title = 'RSUD H. ABDUL MANAP KOTA JAMBI';
      document.removeEventListener('scroll', runToggleScrolled);
      window.removeEventListener('load', runToggleScrolled);
    };
  }, [pageTitle]);

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="/" className="logo d-flex align-items-center me-auto">
          <LazyLoadImage
            src="/img/logors-512.webp"
            srcSet="/img/logors-256.webp 256w,
                    /img/logors-512.webp 512w,
                    /img/logors-1024.webp 1024w"
            sizes="(max-width: 768px) 100vw, 50vw"
            className="img-fluid"
            alt="Logo RSUD H. Abdul Manap Kota Jambi"
            effect="blur"
            scrollPosition={scrollPosition}
            width="200"
            height="131"
            loading="lazy"
          />
        </a>
      </div>
    </header>
  );
};

export default trackWindowScroll(Header);
